import React, { useState, useEffect, useRef } from "react";
import { Image, List, Divider, Loader } from "semantic-ui-react";

import Moment from "react-moment";
import { usePermissionsSimplified } from "../../../../hooks/usePermissionsSimplified";
import UserProfilePlaceholder, {
  LetteredAvatarImageUrl,
} from "../../../components/common/userProfilePlaceholder";
import { useHistory } from "react-router-dom";
import { selectTranslations } from "../../../config/i18n/slice";
import { useDispatch, useSelector } from "react-redux";
import {
  LinkBlueIcon,
  LocationDropDownIcon,
  LocationDropDownIconBlue,
  SubLocationDropDownBlueIcon,
} from "../../../../Assets/Icons/svg";
import moment from "moment";
import { getAllParentLocations } from "../../../config/sharedApi/locationApis";
import { humanize } from "../../../config/common/commonFunctions";

const Details = ({ targetedData }) => {
  const history = useHistory();

  const dispatch = useDispatch();
  const t = useSelector(selectTranslations);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [locOption, setLocOption] = useState([]);

  const organisationId = useSelector((state) => {
    if (state?.auth?.user?.organisation) {
      return state.auth.user.organisation.id;
    } else {
      return null;
    }
  });
  const roleData = useSelector((state) => {
    if (state?.auth?.user?.id) {
      return state.auth.user.role.type;
    } else {
      return null;
    }
  });
  const selectedLanguage = useSelector((state) => {
    if (state?.i18n?.lang) {
      return state.i18n.lang;
    } else {
      return "en";
    }
  });

  useEffect(() => {
    setFetchLoading(true);

    const fetchLocOption = async () => {
      if (
        targetedData?.attributes?.locations &&
        targetedData?.attributes?.locations?.data?.length
      ) {
        const fetchData = await getAllParentLocations(
          organisationId,
          "",
          1,
          99999,
          [],
          [],
          [],
          ["name:asc"]
        );
        let the_options = [];
        let parentOptions = [];
        let subOptions = [];

        const allIds = targetedData?.attributes?.locations?.data?.length
          ? targetedData?.attributes?.locations?.data?.map((each) => each?.id)
          : [];

        if (fetchData?.response?.length > 0 && allIds.length > 0) {
          fetchData.response.forEach((el) => {
            const subLocationCount =
              el?.attributes?.subLocations?.data?.filter((subEl) =>
                allIds.includes(subEl.id)
              ).length || 0;

            if (allIds?.includes(el.id)) {
              parentOptions.push({
                key: el.id,
                value: el.id,
                text: el.attributes.name,
                countId: el.attributes.countId,
                subLocationCount: subLocationCount,

                disabled: false,
              });

              if (el?.attributes?.subLocations?.data?.length > 0) {
                el.attributes.subLocations.data.forEach((subEl) => {
                  if (allIds?.includes(subEl.id)) {
                    subOptions.push({
                      key: subEl.id,
                      value: subEl.id,
                      text: subEl.attributes.name,
                      countId: subEl.attributes.countId,

                      className: "sub-location-dropdown-option",
                      parentId: el.id,
                    });
                  }
                });
              }
            } else {
              const hasMatchingSubLocation = el?.attributes?.subLocations?.data?.some(
                (subEl) => allIds?.includes(subEl.id)
              );

              if (hasMatchingSubLocation) {
                parentOptions.push({
                  key: el.id,
                  value: el.id,
                  subLocationCount,
                  text: el.attributes.name,
                  countId: el.attributes.countId,

                  disabled: true,
                });

                el?.attributes?.subLocations?.data?.length > 0 &&
                  el.attributes.subLocations.data.forEach((subEl) => {
                    if (allIds?.includes(subEl.id)) {
                      subOptions.push({
                        key: subEl.id,
                        value: subEl.id,
                        text: subEl.attributes.name,
                        countId: subEl.attributes.countId,

                        className: "sub-location-dropdown-option",
                        parentId: el.id,
                      });
                    }
                  });
              }
            }
          });

          subOptions.sort((a, b) => a.text.localeCompare(b.text));

          parentOptions.forEach((parentOption) => {
            the_options.push(parentOption);

            subOptions.forEach((subOption) => {
              if (subOption.parentId === parentOption.key) {
                the_options.push(subOption);
              }
            });
          });

          setLocOption(the_options);

          return the_options;
        }
      }
    };

    const loadData = async () => {
      await fetchLocOption();
      setFetchLoading(false);
    };
    loadData();
  }, [targetedData]);
  return (
    <>
      {!fetchLoading ? (
        <div className="preview-details-wrapper">
          <div className="intro">
            <div className="flexbox align-center">
              <div>
                {targetedData?.attributes?.images?.data?.attributes?.url ? (
                  <div className="d-flex align-items-center">
                    <div className="customer-img text-center">
                      <Image
                        circular
                        className=""
                        title={targetedData.attributes?.name}
                        src={`${targetedData?.attributes?.images.data.attributes.url}`}
                        // style={
                        //   selectedLanguage === "en"
                        //     ? { width: "80px", height: "80px", right: "6px" }
                        //     : { width: "80px", height: "80px", right: "-6px" }
                        // }
                      />
                    </div>
                    <div className="username-container ml-2">
                      <p className="people-text text-start">
                        {targetedData?.attributes?.name
                          ? humanize(targetedData?.attributes?.name)
                          : ""}
                      </p>
                    </div>
                  </div>
                ) : (
                  <div className="d-flex align-items-center">
                    <div className="text-center">
                      <UserProfilePlaceholder
                        name={targetedData?.attributes?.name}
                        width={"80px"}
                        height={"80px"}
                        right={selectedLanguage === "en" ? "6px" : "-6px"}
                      />
                    </div>
                    <div className="username-container ml-1">
                      <p className="people-text text-start">
                        {targetedData?.attributes?.name
                          ? humanize(targetedData?.attributes?.name)
                          : ""}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <Divider />

          <div className="d-flex align-items-center mt-3">
            <label className="workorder-intro-label team-label">
              {t.teams.team_info_form.description}
              {":"}
            </label>
            <p className="workorder-intro-value">
              {targetedData?.attributes?.description || t.common.na}
            </p>
          </div>
          <div className="w-100">
            <div className="d-flex align-items-start mt-5">
              <label className="label-item ">
                {""}
                <label className="workorder-intro-label team-label">
                  {t.teams.team_info_form.superior}
                  {":"}
                </label>
              </label>

              <p
                className={`workorder-intro-value supervisor ${
                  selectedLanguage == "en"
                    ? targetedData?.attributes?.superior?.data
                      ? "ml-3 detail-intro-link"
                      : "ml-5"
                    : targetedData?.attributes?.superior?.data
                    ? "mr-3 detail-intro-link"
                    : "mr-5"
                }`}
              >
                {targetedData?.attributes?.superior?.data ? (
                  <div>
                    <Image
                    className="teams-img"
                      avatar
                      title={
                        targetedData?.attributes.superior?.data?.attributes
                          ?.firstName +
                        " " +
                        targetedData?.attributes?.superior?.data?.attributes
                          ?.lastName
                      }
                      src={
                        targetedData?.attributes.superior?.data?.attributes
                          .profileImage.data
                          ? targetedData?.attributes.superior?.data?.attributes
                              .profileImage.data?.attributes?.url
                          : LetteredAvatarImageUrl(
                              targetedData?.attributes.superior?.data
                                ?.attributes?.firstName +
                                " " +
                                targetedData?.attributes?.superior?.data
                                  ?.attributes?.lastName
                            )
                      }
                      // style={{ width: "34px", height: "34px" }}
                    />
                    <span
                      onClick={() => {
                        history.push(
                          `/people?id=${targetedData?.attributes?.superior?.data?.attributes?.countId}`
                        );
                      }}
                      className="ml-1"
                    >
                      {targetedData?.attributes.superior?.data?.attributes
                        ?.firstName +
                        " " +
                        targetedData?.attributes?.superior?.data?.attributes
                          ?.lastName}
                    </span>
                  </div>
                ) : (
                  t.common.na
                )}
              </p>
            </div>
          </div>
          <div className="location-container w-100">
            <div className="d-flex align-items-start mt-5">
              <label className="label-item ">
                {""}
                <label className="workorder-intro-label team-label">
                  {t.teams.team_info_form.location}{" "}
                  {`${
                    targetedData?.attributes?.locations?.data
                      ? `(${targetedData?.attributes?.locations?.data.length})`
                      : ""
                  }`}
                  {":"}
                </label>
              </label>

              <p
                // style={{ gap: "10px" }}
                className="loc-list workorder-intro-value d-flex text-left flex-column"
              >
                {locOption?.length > 0
                  ? locOption.map((each) => {
                      if (!each?.parentId) {
                        return (
                          <span
                            key={each?.key}
                            className={`${
                              selectedLanguage === "en"
                                ? "text-left"
                                : "text-right"
                            }`}
                            basic
                            onClick={() => {
                              if (
                                !each?.disabled ||
                                ["super_admin"]?.includes(roleData)
                              ) {
                                history.push(`/locations?id=${each?.countId}`);
                              }
                            }}
                          >
                            <span>
                              {roleData == "super_admin" ? (
                                <LocationDropDownIconBlue />
                              ) : each?.disabled ? (
                                <LocationDropDownIcon />
                              ) : (
                                <LocationDropDownIconBlue />
                              )}
                            </span>
                            <span
                              className={`
                                ${
                                  selectedLanguage === "en"
                                    ? "ml-2  hii"
                                    : "mr-2"
                                }
                           ${
                             roleData == "super_admin"
                               ? "work-order-link"
                               : each?.disabled
                               ? ""
                               : "work-order-link"
                           }
                              `}
                            >
                              {each?.text}
                            </span>
                            <span className="ml-2 mr-2 blu-text link-span">
                              {each?.subLocationCount > 0 ? (
                                <LinkBlueIcon />
                              ) : null}
                              <span className="ml-1 text-decoration-none">
                                {each?.subLocationCount &&
                                each?.subLocationCount > 1
                                  ? each?.subLocationCount
                                  : ""}
                              </span>
                            </span>
                          </span>
                        );
                      }

                      const parent = locOption.find(
                        (parent) => parent.key === each?.parentId
                      );

                      if (parent?.disabled) {
                        return (
                          <span
                            className={`${
                              selectedLanguage == "en"
                                ? "text-left"
                                : "text-right"
                            } `}
                            basic
                            onClick={() => {
                              if (
                                !each?.disabled ||
                                ["super_admin"]?.includes(roleData)
                              ) {
                                history.push(`/locations?id=${each?.countId}`);
                              }
                            }}
                          >
                            <span
                              className={
                                each?.parentId
                                  ? selectedLanguage == "en"
                                    ? "ml-5"
                                    : "mr-5"
                                  : ""
                              }
                            >
                              {each?.parentId ? (
                                <SubLocationDropDownBlueIcon />
                              ) : roleData == "super_admin" ? (
                                <LocationDropDownIconBlue />
                              ) : each?.disabled ? (
                                <LocationDropDownIcon />
                              ) : (
                                <LocationDropDownIconBlue />
                              )}
                            </span>
                            <span
                              className={`${
                                roleData == "super_admin"
                                  ? "work-order-link"
                                  : each?.disabled
                                  ? ""
                                  : "work-order-link"
                              } ${selectedLanguage == "en" ? "ml-2" : "mr-2"}`}
                            >
                              {each?.text}
                            </span>
                            <span className="ml-2 mr-2 blue-text link-span">
                              {each?.subLocationCount &&
                              each?.subLocationCount > 0 ? (
                                <LinkBlueIcon />
                              ) : null}
                              <span className="ml-1 text-decoration-none">
                                {each?.subLocationCount &&
                                each?.subLocationCount > 1
                                  ? each?.subLocationCount
                                  : ""}
                              </span>
                            </span>
                          </span>
                        );
                      }

                      return null;
                    })
                  : t.common.na}
              </p>
            </div>
          </div>

          <div className="d-flex align-items-start mt-5">
            {""}
            <label className="workorder-intro-label team-label">
              {t.teams.team_info_form.customer}{" "}
              {`${
                targetedData?.attributes?.customers?.data
                  ? `(${targetedData?.attributes.customers.data.length})`
                  : ""
              }`}
              {":"}
            </label>

            <p
              className={`workorder-intro-value supervisor  mt-1 ${
                selectedLanguage == "en"
                  ? targetedData?.attributes?.customers?.data.length > 0
                    ? "detail-intro-link ml-3"
                    : "ml-5"
                  : targetedData?.attributes?.customers?.data?.length > 0
                  ? "detail-intro-link mr-3"
                  : "mr-5"
              }`}
            >
              {targetedData?.attributes.customers?.data?.length > 0
                ? targetedData?.attributes?.customers?.data?.map(
                    (el, index) => (
                      <List.Item className={`d-flex mb-3`}>
                        <div className="d-flex  ">
                          <Image
                            avatar
                            title={el.attributes?.name}
                            src={
                              el.attributes.logo?.data?.attributes?.url
                                ? el.attributes.logo?.data?.attributes?.url
                                : LetteredAvatarImageUrl(el.attributes?.name)
                            }
                            className="teams-img"
                            // style={{ width: "34px", height: "34px" }}
                          />
                        </div>

                        <span
                          onClick={() => {
                            history.push(
                              `/customers?id=${el?.attributes?.countId}`
                            );
                          }}
                          className="mt-1 ml-1"
                        >
                          {el?.attributes?.name}
                        </span>
                      </List.Item>
                    )
                  )
                : t.common.na}
            </p>
          </div>

          <div className="d-flex align-items-start mt-5">
            <label className="label-item mt-1">
              {""}
              <label className="workorder-intro-label team-label">
                {t.teams.team_info_form.team_members}{" "}
                {`${
                  targetedData?.attributes?.users?.data
                    ? `(${targetedData?.attributes.users.data.length})`
                    : ""
                }`}
                {":"}
              </label>
            </label>

            <p
              className={`workorder-intro-value users-data ${
                targetedData?.attributes?.users?.data?.length > 0
                  ? "detail-intro-link"
                  : ""
              }`}
            >
              {targetedData?.attributes.users.data.length > 0
                ? targetedData?.attributes?.users?.data?.map((el, index) => (
                    <List.Item className={`d-flex mb-3`}>
                      <div className="d-flex  ">
                        <Image
                          avatar
                          className="user-img"
                          title={
                            el.attributes?.firstName +
                            " " +
                            el?.attributes?.lastName
                          }
                          src={
                            el.attributes.profileImage?.data
                              ? el.attributes?.profileImage?.data.attributes.url
                              : LetteredAvatarImageUrl(
                                  el.attributes?.firstName +
                                    " " +
                                    el?.attributes?.lastName
                                )
                          }
                          // style={
                          //   selectedLanguage == "en"
                          //     ? { width: "34px", height: "34px", right: "6px" }
                          //     : { width: "34px", height: "34px", right: "-6px" }
                          // }
                        />
                      </div>

                      <span
                        onClick={() => {
                          history.push(`/people?id=${el?.attributes?.countId}`);
                        }}
                        className="mt-1 ml-1"
                      >
                        {el?.attributes?.firstName +
                          " " +
                          el?.attributes?.lastName}
                      </span>
                    </List.Item>
                  ))
                : t.common.na}
            </p>
          </div>
          <Divider />

          <div className="d-flex align-items-center mt-5">
            <label
              className="workorder-intro-label created-user team-label grey"
              // style={{ minWidth: "77px" }}
            >
              {t.workOrders.table.createdByUser}
              {":"}
            </label>
            <p className="workorder-intro-value grey">
              {targetedData?.attributes?.createdByUser?.data?.attributes
                ?.firstName &&
              targetedData?.attributes?.createdByUser?.data?.attributes
                ?.lastName
                ? targetedData?.attributes?.createdByUser?.data?.attributes
                    ?.firstName +
                  " " +
                  targetedData?.attributes?.createdByUser?.data?.attributes
                    ?.lastName
                : t.common.na}
              {", "}
              <Moment
                format="DD/MM/YYYY LT"
                date={targetedData?.attributes?.createdAt}
              />
            </p>
          </div>

          <div className="d-flex align-items-center mt-3">
            <label className="workorder-intro-label team-label grey">
              {t.common.update_by}
              {":"}
            </label>
            <p className="workorder-intro-value grey">
              {targetedData?.attributes?.updatedByUser?.data
                ? targetedData?.attributes?.updatedByUser?.data?.attributes
                    ?.firstName +
                  " " +
                  targetedData?.attributes?.updatedByUser?.data?.attributes
                    ?.lastName +
                  ", " +
                  moment(targetedData?.attributes?.updatedAt).format(
                    "DD/MM/YYYY LT"
                  )
                : t.common.na}
            </p>
          </div>
        </div>
      ) : (
        <Loader active inline="centered">
          {t.common.loading}
        </Loader>
      )}
    </>
  );
};

export default Details;
